import { useEffect, useState } from 'react'

const SWEEP_MS = 400
const MAX_STEP_MS = 12

const reduced = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches

// Fires on a compact -> expanded flip of the same mounted grid. With mountDelayMs it
// also sweeps once on mount, after that delay (e.g. once a sheet's own reveal is done).
export function useExpandStagger(compact: boolean, mountDelayMs?: number) {
  const [prev, setPrev] = useState(compact)
  const [on, setOn] = useState(() => mountDelayMs !== undefined && !reduced())
  const [delay, setDelay] = useState(mountDelayMs ?? 0)
  if (prev !== compact) {
    setPrev(compact)
    setOn(prev && !compact && !reduced())
    setDelay(0)
  }
  useEffect(() => {
    if (!on) return
    const t = setTimeout(() => setOn(false), delay + SWEEP_MS + 400)
    return () => clearTimeout(t)
  }, [on, delay])
  return {
    cls: on ? ' dot-expand' : '',
    at: (i: number, n: number) =>
      on ? { animationDelay: `${delay + i * Math.min(MAX_STEP_MS, SWEEP_MS / n)}ms` } : undefined,
  }
}
